const urls = {
  /*首页*/
  home: {
    homeData: 'http://newtest.solar-iot.com/api/home/data',
    projectGet: 'http://newtest.solar-iot.com/api/device/project/get',
    companyList: 'http://newtest.solar-iot.com/api/home/company_list',
    homeWeb_info: 'http://newtest.solar-iot.com/api/home/web_info',
    logout: 'http://newtest.solar-iot.com/api/home/logout',
    wss: 'wss://newtest.solar-iot.com/wss',

  },
  /*策略*/
  strategy: {
    save: 'http://newtest.solar-iot.com/api/policy/save',
    getlist: 'http://newtest.solar-iot.com/api/policy/getlist',
    policy_detail: 'http://newtest.solar-iot.com/api/policy/policy_detail',
    del_policy: 'http://newtest.solar-iot.com/api/policy/del_policy',

    // nav:'http://newtest.solar-iot.com/api/policy/nav',
    policy_nav: 'http://newtest.solar-iot.com/api/policy/policy_nav',
    set_policy: 'http://newtest.solar-iot.com/api/policy/set_policy',

    sublist: 'http://newtest.solar-iot.com/api/policy/sublist',
    addSubPolicy: 'http://newtest.solar-iot.com/api/policy/addSubPolicy',
    updateSubPolicy: 'http://newtest.solar-iot.com/api/policy/updateSubPolicy',
    delPolicy: 'http://newtest.solar-iot.com/api/policy/delPolicy',
    getPolicyLoadInfo: 'http://newtest.solar-iot.com/api/policy/getPolicyLoadInfo',
    setPolicyLoadInfo: 'http://newtest.solar-iot.com/api/policy/setPolicyLoadInfo',
    getPolicyOutLoadInfo: 'http://newtest.solar-iot.com/api/policy/getPolicyOutLoadInfo',
    setPolicyOutLoadInfo: 'http://newtest.solar-iot.com/api/policy/setPolicyOutLoadInfo',
  },
  /*项目管理*/
  device: {
    getCountry: 'http://newtest.solar-iot.com/api/common/get_country',//获取国家列表
    getProvince: 'http://newtest.solar-iot.com/api/common/get_province',//获取省份列表
    getCity: 'http://newtest.solar-iot.com/api/common/get_city',//获取城市列表
    getArea: 'http://newtest.solar-iot.com/api/common/get_area',//获取行政区列表
    projectGet_pram_data: 'http://newtest.solar-iot.com/api/device/project/get_pram_data',
    projectData: 'http://newtest.solar-iot.com/api/device/project/data',

    projectDetail: 'http://newtest.solar-iot.com/api/device/project/detail',
    projectNav: 'http://newtest.solar-iot.com/api/device/project/nav',
    projectSave: 'http://newtest.solar-iot.com/api/device/project/save',
    lampcontrolGet: 'http://newtest.solar-iot.com/api/device/lampcontrol/get',/*表格数据*/
    commonFields: 'http://newtest.solar-iot.com/api/home/fields',/*字段管理*/
    projectDel: 'http://newtest.solar-iot.com/api/device/project/del',/*项目删除*/
    lampcontrolHistorylist: 'http://newtest.solar-iot.com/api/device/lampcontrol/historylist',/*灯控历史数据*/

    networkDetail: 'http://newtest.solar-iot.com/api/device/network/detail',/*组网详情*/
    networkSave: 'http://newtest.solar-iot.com/api/device/network/save',/*添加组网*/
    networkDel: 'http://newtest.solar-iot.com/api/device/network/del',/*组网删除*/

    lampcontrolSave: 'http://newtest.solar-iot.com/api/device/lampcontrol/save',/*添加灯控*/
    lampcontrolTurnonoff: 'http://newtest.solar-iot.com/api/device/lampcontrol/turnonoff',/*灯控开关灯*/
    lampcontrolDel: 'http://newtest.solar-iot.com/api/device/lampcontrol/del',/*灯控删除*/
    lampcontrolViewloglist: 'http://newtest.solar-iot.com/api/device/lampcontrol/viewloglist',/*灯控详情*/
    lampcontrolUpdate: 'http://newtest.solar-iot.com/api/device/lampcontrol/update',/*数据更新*/

    // videoGetlist:'http://newtest.solar-iot.com/api/video/getlist',/*视频监控列表*/
    // weatherGetlist:'http://newtest.solar-iot.com/api/weather/getlist',/*天气监控列表*/
    workmode: 'http://newtest.solar-iot.com/api/common/workmode',/*路灯负载模式下拉列表*/
    loadSetting: 'http://newtest.solar-iot.com/api/device/lampcontrol/load_setting',/*读取灯控负载设置*/
    modbusGetLoad: 'http://newtest.solar-iot.com/api/device/lampcontrol/modbus_get_load',/*读取新的灯控负载设置*/
    setLoad: 'http://newtest.solar-iot.com/api/device/lampcontrol/set_load',/*路灯负载设置*/
    modbusSetLoad: 'http://newtest.solar-iot.com/api/device/lampcontrol/modbus_set_load',/*新的路灯负载设置*/

    projectSetPramData: 'http://newtest.solar-iot.com/api/device/project/set_pram_data',/*路灯项目负载设置*/
    batterySetting: 'http://newtest.solar-iot.com/api/device/lampcontrol/battery_setting',/*读取灯控蓄电池设置*/
    modbusGetBattery: 'http://newtest.solar-iot.com/api/device/lampcontrol/modbus_get_battery',/*读取新的灯控蓄电池设置*/

    setBattery: 'http://newtest.solar-iot.com/api/device/lampcontrol/set_battery',/*蓄电池参数设置*/
    modbusSetBattery: 'http://newtest.solar-iot.com/api/device/lampcontrol/modbus_set_battery',/*新的蓄电池参数设置*/

    lampcontrolGetData: 'http://newtest.solar-iot.com/api/device/lampcontrol/get_data',/*获取默认参数设置*/
    modbusGetData: 'http://newtest.solar-iot.com/api/device/lampcontrol/modbus_get_data',/*获取新控制器默认参数设置*/

    // provinceList:'http://newtest.solar-iot.com/api/home/province_list',
    zoneList: 'http://newtest.solar-iot.com/api/home/zone_list',
    timezoneList: 'http://newtest.solar-iot.com/api/home/timezone_list',/*时区列表*/

    lampcontrolBatchInput: 'http://newtest.solar-iot.com/api/device/lampcontrol/batchInput',
    excelModel: 'http://newtest.solar-iot.com/api//file/ExcelModel/路灯信息模版.xls',
    excelModelEN: 'http://newtest.solar-iot.com/api//file/ExcelModel/lamp_model.xls',

    lampHistoryData: 'http://newtest.solar-iot.com/api/device/lampcontrol/lamp_history_data',/*路灯历史数据*/
    getLampList: 'http://newtest.solar-iot.com/api/home/lamp_list',/*获取历史路灯数据列表*/

    upgrade: 'http://newtest.solar-iot.com/api/device/project/upgrade',

    electric_get_status: 'http://newtest.solar-iot.com/api/electric/get_status',/*获取电机开关状态*/
    electric_set_status: 'http://newtest.solar-iot.com/api/electric/set_status',/*设置电机开关状态*/
    electric_get_date_delay: 'http://newtest.solar-iot.com/api/electric/get_date_delay',/*获取电机日期跟延时设置*/
    electric_set_date_delay: 'http://newtest.solar-iot.com/api/electric/set_date_delay',/*设置电机的日期跟延时*/
    electric_get_timing: 'http://newtest.solar-iot.com/api/electric/get_timing',/*获取电机校时时间*/
    electric_set_timing: 'http://newtest.solar-iot.com/api/electric/set_timing',/*设置电机校时*/

    electric_get_dev_info: 'http://newtest.solar-iot.com/api/electric/get_dev_info',/*获取电机所有信息*/
    electric_set_dev_info: 'http://newtest.solar-iot.com/api/electric/set_dev_info',/*设置电机所有信息*/

    get_param_mode_list: 'http://newtest.solar-iot.com/api/device/data/get_param_mode_list', /*参数模板列表*/
    save_param_mode: 'http://newtest.solar-iot.com/api/device/data/save_param_mode', /*添加编辑模板*/
    param_mode_details: 'http://newtest.solar-iot.com/api/device/data/param_mode_details', /*获取模板详情*/
    del_param_mode: 'http://newtest.solar-iot.com/api/device/data/del_param_mode', /*删除模板*/
    param_mode_nav: 'http://newtest.solar-iot.com/api/device/data/param_mode_nav', /*模板下拉列表*/

    project_broadcast_dimming: 'http://newtest.solar-iot.com/api/device/project/broadcast_dimming', /*模板下拉列表*/

    lampcontrol_get_loaction: 'http://newtest.solar-iot.com/api/device/lampcontrol/get_loaction', /*同步定位信息*/

    lampcontrol_lanya_get_battery: 'http://newtest.solar-iot.com/api/device/lampcontrol/lanya_get_battery', /*2.4G设备获取电池参数*/
    lampcontrol_lanya_set_battery: 'http://newtest.solar-iot.com/api/device/lampcontrol/lanya_set_battery', /*2.4G设备设置电池参数*/
    lampcontrol_lanya_get_load_param: 'http://newtest.solar-iot.com/api/device/lampcontrol/lanya_get_load_param', /*2.4G获取负载参数*/
    lampcontrol_lanya_set_load_param: 'http://newtest.solar-iot.com/api/device/lampcontrol/lanya_set_load_param', /*2.4G设备设置负载参数*/
    lampcontrol_lanya_get_policy_param: 'http://newtest.solar-iot.com/api/device/lampcontrol/lanya_get_policy_param', /*2.4G设备获取策略参数*/
    lampcontrol_lanya_set_policy_param: 'http://newtest.solar-iot.com/api/device/lampcontrol/lanya_set_policy_param', /*2.4G设备设置策略参数*/
    lampcontrol_lanya_get_battery_def: 'http://newtest.solar-iot.com/api/device/lampcontrol/lanya_get_battery_def', /*2.4G设备获取电池默认参数*/
    lampcontrol_lanya_get_policy_param_def: 'http://newtest.solar-iot.com/api/device/lampcontrol/lanya_get_policy_param_def', /*2.4G获取策略默认参数*/


    lampcontrol_activateDevice: 'http://newtest.solar-iot.com/api/device/lampcontrol/activateDevice', /*lorawan激活设备*/

  },
  history: {
    reportHome: 'http://newtest.solar-iot.com/api/report/home',/*历史数据首页数据*/
    reportData: 'http://newtest.solar-iot.com/api/report/data',/*各项报表数据*/
  },
  alarm: {
    setPatrolCmd: 'http://newtest.solar-iot.com/api/device/lampcontrol/set_patrol_cmd',

    alarmGet: 'http://newtest.solar-iot.com/api/alarm/get',/*告警信息列表*/
    alarmSet: 'http://newtest.solar-iot.com/api/alarm/set',/*更改故障状态*/
    patrol_list: 'http://newtest.solar-iot.com/api/alarm/patrol_list',/*巡检信息列表*/

    repairUser: 'http://newtest.solar-iot.com/api/repair/repair_user',/*维修人*/
    nearRepairList: 'http://newtest.solar-iot.com/api/repair/near_repair_list',/*近期维修列表*/
    repairUserList: 'http://newtest.solar-iot.com/api/repair/repair_user_list',/*维修人员列表*/
    userInfo: 'http://newtest.solar-iot.com/api/repair/user_info',/*维修人员详情*/
    saveRepairUser: 'http://newtest.solar-iot.com/api/repair/save_repair_user',/*添加维修人员*/
    delRepairUser: 'http://newtest.solar-iot.com/api/repair/del_repair_user',/*删除维修人员*/

    alarmRepairInfo: 'http://newtest.solar-iot.com/api/alarm/repair_info',/*维修信息*/
    repairList: 'http://newtest.solar-iot.com/api/repair/repair_list',/*维修记录列表*/
    saveRepairInfo: 'http://newtest.solar-iot.com/api/repair/save_repair_info',/*添加/编辑维修记录*/
    repairInfo: 'http://newtest.solar-iot.com/api/repair/repair_info',/*维修信息详情*/
    delRepairInfo: 'http://newtest.solar-iot.com/api/repair/del_repair_info',/*删除维修信息*/
    alarmDel: 'http://newtest.solar-iot.com/api/alarm/del',/*删除/清除故障信息*/

    networkGet: 'http://newtest.solar-iot.com/api/device/network/get',/*网络下拉列表*/
    networkSectionList: 'http://newtest.solar-iot.com/api/device/network/network_section_list',/*网络路段列表*/
    lampList: 'http://newtest.solar-iot.com/api/home/lamp_list',/*路灯下拉列表*/
    userList: 'http://newtest.solar-iot.com/api/repair/user_list',/*维修人员下拉列表*/
    alarmTypeList: 'http://newtest.solar-iot.com/api/home/alarm_type_list',/*告警状态下拉列表*/

    patrolPost: 'http://newtest.solar-iot.com/api/device/project/patrol',/*巡检设置*/
  },
  gisMap: {
    mapGet: 'http://newtest.solar-iot.com/api/map/get',/*地图首页数据*/
    lampInfo: 'http://newtest.solar-iot.com/api/map/lamp_info',/*路灯信息*/
    turnonoff: 'http://newtest.solar-iot.com/api/map/turnonoff',
    projectInfo: 'http://newtest.solar-iot.com/api/map/project_info',/*项目信息*/
    projectListUrl: 'http://newtest.solar-iot.com/api/map/project_list',/*项目列表*/
    monitorInfo: 'http://newtest.solar-iot.com/api/map/monitor_info',/*监控信息*/
    lampcontrolDimming: 'http://newtest.solar-iot.com/api/device/lampcontrol/dimming',/*灯控调光*/
    dataList: 'http://newtest.solar-iot.com/api/map/data_list',/*项目信息查看列表*/
    faultInfo: 'http://newtest.solar-iot.com/api/map/fault_info',
    grouplist: 'http://newtest.solar-iot.com/api/policy/grouplist',/*获取分组列表*/
    policyGroupset: 'http://newtest.solar-iot.com/api/policy/groupset',/*分组设置*/
    policyGroupinfo: 'http://newtest.solar-iot.com/api/policy/groupinfo',/*分组详情*/
    repairDispatch: 'http://newtest.solar-iot.com/api/repair/repair_dispatch',/*维修调度*/
    getProjectCompany: 'http://newtest.solar-iot.com/api/device/data/get_project_company',/*获取灯控公司与所属项目*/
    getLngLat: 'http://newtest.solar-iot.com/api/home/get_lng_lat',

    changeLocation: 'http://newtest.solar-iot.com/api/device/lampcontrol/change_location',/*改变路灯坐标*/
    lampList: 'http://newtest.solar-iot.com/api/map/lamp_list',/*地图页路灯列表*/
    videoList: 'http://newtest.solar-iot.com/api/map/video_list',/*视屏监控位置获取*/

    dateNav: 'http://newtest.solar-iot.com/api/map/date_nav', /*GIS下拉信息*/
    lampData: 'http://newtest.solar-iot.com/api/map/lamp_data', /*路灯信息*/
    sectionData: 'http://newtest.solar-iot.com/api/map/section_data', /*路段信息*/
    projectData: 'http://newtest.solar-iot.com/api/map/project_data', /*项目信息*/
    section_nav: 'http://newtest.solar-iot.com/api/map/section_nav', /*路段下拉列表*/
    alarmData: 'http://newtest.solar-iot.com/api/map/alarm_data', /*故障信息列表*/
    changeDirection: 'http://newtest.solar-iot.com/api/map/change_direction', /*修改路灯地图方向*/
  },
  syslog: {
    getList: 'http://newtest.solar-iot.com/api/syslog/get_list',/*日志列表*/
  },
  video: {
    getlist: 'http://newtest.solar-iot.com/api/video/getlist',/*视频监控列表*/
    videoInfo: 'http://newtest.solar-iot.com/api/video/video_info',/*视频监控详情*/
    videoPlay: 'http://newtest.solar-iot.com/api/video/video_play',
    videoUpdate: 'http://newtest.solar-iot.com/api/video/update',
    /*视频监控添加和修改*/
    videoDelete: 'http://newtest.solar-iot.com/api/video/del',
    /*视频监控批量删除*/
    starVideoControl: 'http://newtest.solar-iot.com/api/video/yun_start',
    /*视频监控云台控制*/
    stopVideoControl: 'http://newtest.solar-iot.com/api/video/yun_end',
    /*视频监控云台控制*/
  },
  /*分组策略*/
  group: {
    getGrouplist: 'http://newtest.solar-iot.com/api/policy/get_grouplist',/*分组列表*/
    groupinfo: 'http://newtest.solar-iot.com/api/policy/groupinfo',/*分组详情*/
    lampList: 'http://newtest.solar-iot.com/api/policy/lamp_list',/*分组设置页添加路灯列表*/
    groupsave: 'http://newtest.solar-iot.com/api/policy/groupsave',/*分组添加/编辑路灯*/
    groupDel: 'http://newtest.solar-iot.com/api/policy/del_group',
    lampdel: 'http://newtest.solar-iot.com/api/policy/lampdel',/*分组灯控删除*/

    getlist: 'http://newtest.solar-iot.com/api/policy/getlist',/*策略列表*/
    policySave: 'http://newtest.solar-iot.com/api/policy/save',/*添加/编辑策略*/
    policyDetail: 'http://newtest.solar-iot.com/api/policy/policy_detail',/*策略详情*/
    delPolicy: 'http://newtest.solar-iot.com/api/policy/del_policy',/*策略删除*/
  },
  /*个人中心*/
  user: {
    userInfo: 'http://newtest.solar-iot.com/api/user/info',/*用户信息*/
    updateUserInfo: 'http://newtest.solar-iot.com/api/user/update_user_info',/*编辑用户信息*/
    userPassword: 'http://newtest.solar-iot.com/api/user/password',/*修改密码*/
    userCompanyList: 'http://newtest.solar-iot.com/api/user/company_list',/*公司列表*/
    subList: 'http://newtest.solar-iot.com/api/user/sub_list',/*公司子账户列表*/
    zoneList: 'http://newtest.solar-iot.com/api/user/zone_list',/*区域列表*/
    privilegeList: 'http://newtest.solar-iot.com/api/user/privilege_list',/*权限列表*/
    saveUserPrivilege: 'http://newtest.solar-iot.com/api/user/save_user_privilege',/*修改用户权限*/
    userUpdate: 'http://newtest.solar-iot.com/api/user/user_update',/*添加/编辑账户*/
    feedback: 'http://newtest.solar-iot.com/api/user/feedback',/*用户反馈*/
    about: 'http://newtest.solar-iot.com/api/user/about',/*关于我们*/
    userUser_info: 'http://newtest.solar-iot.com/api/user/user_info',/*账户详情*/
    saveZone: 'http://newtest.solar-iot.com/api/user/save_zone',/*添加/编辑区域*/
    getZoneList: 'http://newtest.solar-iot.com/api/user/get_zone_list',/*添加区域下拉*/
    getPorjectList: 'http://newtest.solar-iot.com/api/user/get_porject_list',/*项目权限列表*/
    saveUserProject: 'http://newtest.solar-iot.com/api/user/save_user_project',/*修改项目权限*/
    companySave: 'http://newtest.solar-iot.com/api/company/save',/*添加/编辑公司*/
    companyDel: 'http://newtest.solar-iot.com/api/company/del',/*公司删除*/
    companyInfo: 'http://newtest.solar-iot.com/api/company/info',/*获取公司详情*/
    blockUser: 'http://newtest.solar-iot.com/api/user/block_user',/*修改账户状态*/
    delZone: 'http://newtest.solar-iot.com/api/user/del_zone',/*删除区域*/
    addWebLogo: 'http://newtest.solar-iot.com/api/user/add_web_logo',/*上传用户网页定制logo*/
  },
  /*天气监控*/
  weather: {
    getList: 'http://newtest.solar-iot.com/api/weather/getlist',/*首页数据*/
    update: 'http://newtest.solar-iot.com/api/weather/update',/*添加或编辑监控*/
    info: 'http://newtest.solar-iot.com/api/weather/info',/*监控详情*/
    del: 'http://newtest.solar-iot.com/api/weather/del',/*监控删除*/
    dataList: 'http://newtest.solar-iot.com/api/weather/data_list',/*环境监控数据报表*/
    dataCom: 'http://newtest.solar-iot.com/api/weather/data_com',/*数据对比*/
  }
}
export default urls


// WEBPACK FOOTER //
// ./src/api/allUel.js